import { Page, PagePermissionName, PaymentMethod, ShareLinkDuration } from '../types/app';
import { getOptionsFromObject } from '../utils/objects';

export const PUBLIC_ROUTES_SECTION_ID = 'public';
export const DASHBOARD_ROUTES_SECTION_ID = 'dashboard';
export const DASHBOARD_HOME_ROUTE_ID = 'home';
export const DASHBOARD_HOME_ROUTE = '/';

export const LOGIN_PAGE: Page = {
  id: 'login',
  name: 'Inicio de sesión',
  route: '/login',
  permissionName: PagePermissionName.none,
};
export const FORGOTTEN_PASSWORD: Page = {
  id: 'forgottenPassword',
  name: 'Contraseña olvidada',
  route: '/forgotten-password',
  permissionName: PagePermissionName.none,
};
export const LIVE_PAGE: Page = {
  id: 'live',
  name: 'Mapa',
  icon: 'map',
  route: '/dashboard/:id/live',
  permissionName: PagePermissionName.dashboard,
  navKey: 'live',
};
export const REQUEST_VIDEO_PAGE: Page = {
  id: 'requestVideo',
  name: 'Mapa',
  route: '/dashboard/:id/live/request-video/:ident',
  permissionName: PagePermissionName.dashboard,
  navKey: 'live',
};
export const STREAM_PAGE: Page = {
  id: 'stream',
  name: 'Mapa',
  route: '/dashboard/:id/live/stream/:ident',
  permissionName: PagePermissionName.dashboard,
  navKey: 'live',
};
export const PUBLIC_LIVE_PAGE: Page = {
  id: 'publicLive',
  name: 'Mapa',
  route: '/live/:shareLinkId',
  permissionName: PagePermissionName.none,
};
export const COMMANDS_PAGE: Page = {
  id: 'commands',
  name: 'Comandos',
  icon: 'settings_remote',
  route: '/dashboard/:id/commands',
  permissionName: PagePermissionName.commands,
  navKey: 'commands',
};
export const GROUPS_PAGE: Page = {
  id: 'groups',
  name: 'Grupos',
  icon: 'group_work',
  route: '/dashboard/:id/groups',
  permissionName: PagePermissionName.groups,
  navKey: 'groups',
};
export const GEOFENCES_PAGE: Page = {
  id: 'geofences',
  name: 'Geocercos',
  icon: 'place',
  route: '/dashboard/:id/geofences',
  permissionName: PagePermissionName.geofence,
  navKey: 'geofences',
};
export const DELIVERY_GEOFENCES_PAGE: Page = {
  id: 'deliveryFences',
  name: 'Puntos de entrega',
  icon: 'pin_drop',
  route: '/dashboard/:id/delivery-fences',
  permissionName: PagePermissionName.geofence,
  navKey: 'deliveryFences',
};
export const CONVOYS_PAGE: Page = {
  id: 'convoys',
  name: 'Convoys',
  icon: 'local_shipping',
  route: '/dashboard/:id/convoys',
  permissionName: PagePermissionName.convoy,
  navKey: 'convoys',
};
export const CONTROL_TOWER_PAGE: Page = {
  id: 'control-tower',
  name: 'Torre de Control',
  icon: 'view_timeline',
  route: '/dashboard/:id/control-tower',
  permissionName: PagePermissionName.controlTower,
  navKey: 'control-tower',
};
export const GPT_DETAIL_PAGE: Page = {
  id: 'gpt-detail',
  name: 'Evento',
  route: '/dashboard/:id/control-tower/:eventId',
  navKey: 'gptDetail',
  permissionName: PagePermissionName.controlTower,
};
export const JOURNEYS_PAGE: Page = {
  id: 'safe-journeys',
  name: 'Monitoreo virtual',
  icon: 'support_agent',
  route: '/dashboard/:id/safe-journeys',
  permissionName: PagePermissionName.journeys,
  navKey: 'safe-journeys',
};
export const REPORTS_PAGE: Page = {
  id: 'reports',
  name: 'Reportes',
  icon: 'bar_chart',
  route: '/dashboard/:id/reports',
  permissionName: PagePermissionName.reports,
  navKey: 'reports',
};
export const ROUTE_REPORTS_PAGE: Page = {
  id: 'routeReport',
  name: 'Reportes',
  route: '/dashboard/:id/reports/route',
  permissionName: PagePermissionName.reports,
  navKey: 'reports',
};
export const PATHS_REPORTS_PAGE: Page = {
  id: 'pathsReport',
  name: 'Reportes',
  route: '/dashboard/:id/reports/paths',
  permissionName: PagePermissionName.reports,
  navKey: 'reports',
};
export const ALARMS_REPORTS_PAGE: Page = {
  id: 'alarmsReport',
  name: 'Reportes',
  route: '/dashboard/:id/reports/alarms',
  permissionName: PagePermissionName.reports,
  navKey: 'reports',
};
export const EVIDENCES_REPORTS_PAGE: Page = {
  id: 'evidencesReport',
  name: 'Reportes',
  route: '/dashboard/:id/reports/evidences',
  permissionName: PagePermissionName.reports,
  navKey: 'reports',
};
export const EVIDENCE_REPORT_DETAIL_PAGE: Page = {
  id: 'evidenceReportDetail',
  name: 'Reportes',
  route: '/dashboard/:id/reports/evidences/:evidenceId',
  permissionName: PagePermissionName.reports,
  navKey: 'reports',
};
export const TELEMETRY_REPORTS_PAGE: Page = {
  id: 'telemetryReport',
  name: 'Reportes',
  route: '/dashboard/:id/reports/telemetry',
  permissionName: PagePermissionName.reports,
  navKey: 'reports',
};
export const CONSUMPTION_REPORTS_PAGE: Page = {
  id: 'consumptionReport',
  name: 'Reportes',
  route: '/dashboard/:id/reports/consumption',
  permissionName: PagePermissionName.reports,
  navKey: 'reports',
};
export const DOOR_REPORTS_PAGE: Page = {
  id: 'doorReport',
  name: 'Reportes',
  route: '/dashboard/:id/reports/door',
  permissionName: PagePermissionName.reports,
  navKey: 'reports',
};
export const DELIVERY_REPORTS_PAGE: Page = {
  id: 'deliveryReport',
  name: 'Reportes',
  route: '/dashboard/:id/reports/delivery',
  permissionName: PagePermissionName.reports,
  navKey: 'reports',
};
export const DOWNLOADS_PAGE: Page = {
  id: 'downloads',
  name: 'Descargas reportes',
  icon: 'cloud_download',
  route: '/dashboard/:id/downloads',
  permissionName: PagePermissionName.reports,
  navKey: 'downloads',
};
export const SETTINGS_PAGE: Page = {
  id: 'settings',
  name: 'Configuración',
  icon: 'settings',
  route: '/dashboard/:id/account/settings',
  permissionName: PagePermissionName.settings,
  navKey: 'settings',
};
export const ACCOUNT_PAGE: Page = {
  id: 'account',
  name: 'Cuenta de cliente',
  icon: 'settings',
  route: '/dashboard/:id/account/profile/:tab',
  permissionName: PagePermissionName.settings,
  navKey: 'account',
};

export const TRACKING_PAGE: Page = {
  id: 'tracking',
  name: 'Seguimiento',
  route: '/dashboard/:id/tracking/:assetId',
  permissionName: PagePermissionName.dashboard,
};
export const SECONDARIES_PAGE: Page = {
  id: 'secondaries',
  name: 'Dispositivos secundarios',
  route: '/dashboard/:id/secondaries/:assetId',
  permissionName: PagePermissionName.dashboard,
};
export const NOTIFICATION_PAGE: Page = {
  id: 'notification',
  name: 'Notificación',
  route: '/dashboard/:id/notification/:notificationId',
  permissionName: PagePermissionName.dashboard,
};
export const LIVE_STATUS_PAGE: Page = {
  id: 'liveStatus',
  name: 'Live Status',
  route: '/dashboard/:id/livestatus/:identifier',
  permissionName: PagePermissionName.dashboard,
};

export const PLACES_PAGE: Page = {
  id: 'places',
  name: 'Puntos de interés',
  icon: 'home_pin',
  route: '/dashboard/:id/places',
  permissionName: PagePermissionName.none,
  navKey: 'places',
};

export const LINKS_PAGE: Page = {
  id: 'links',
  name: 'Vinculaciones',
  icon: 'link',
  route: '/dashboard/:id/links',
  permissionName: PagePermissionName.links,
  navKey: 'links',
};

export const NOTIFICATION_EVIDENCES_PAGE: Page = {
  id: 'notificationEvidences',
  name: 'Notificaciones',
  route: '/dashboard/:id/notifications/:notificationId/evidences',
  permissionName: PagePermissionName.none,
};
export const NOTIFICATION_EVIDENCE_DETAIL_PAGE: Page = {
  id: 'notificationEvidenceDetail',
  name: 'Notificaciones',
  route: '/dashboard/:id/notifications/:notificationId/evidences/:evidenceId',
  permissionName: PagePermissionName.none,
};

export const ROOT_PAGES: Page[] = [
  LIVE_PAGE,
  COMMANDS_PAGE,
  GROUPS_PAGE,
  GEOFENCES_PAGE,
  DELIVERY_GEOFENCES_PAGE,
  CONTROL_TOWER_PAGE,
  JOURNEYS_PAGE,
  CONVOYS_PAGE,
  LINKS_PAGE,
  PLACES_PAGE,
  REPORTS_PAGE,
  DOWNLOADS_PAGE,
  SETTINGS_PAGE,
];

export const CORE_SECTION_ID = 'core';
export const CORE_PAGE_IDS: string[] = [LIVE_PAGE.id];

export const FLEET_SECTION_ID = 'fleet';
export const FLEET_PAGE_IDS: string[] = [CONTROL_TOWER_PAGE.id, JOURNEYS_PAGE.id, CONVOYS_PAGE.id, LINKS_PAGE.id];

export const ZONE_SECTION_ID = 'zone';
export const ZONE_PAGE_IDS: string[] = [GEOFENCES_PAGE.id, DELIVERY_GEOFENCES_PAGE.id, PLACES_PAGE.id];

export const OTHER_SECTION_ID = 'other';
export const OTHER_PAGE_IDS: string[] = [
  COMMANDS_PAGE.id,
  REPORTS_PAGE.id,
  DOWNLOADS_PAGE.id,
  GROUPS_PAGE.id,
  SETTINGS_PAGE.id,
];
export const OTHER_All_WORKSPACES_PAGE_IDS: string[] = [COMMANDS_PAGE.id, REPORTS_PAGE.id, DOWNLOADS_PAGE.id];

export const ALL_PAGES: Page[] = [
  LOGIN_PAGE,
  FORGOTTEN_PASSWORD,
  LIVE_PAGE,
  REQUEST_VIDEO_PAGE,
  STREAM_PAGE,
  PUBLIC_LIVE_PAGE,
  COMMANDS_PAGE,
  GROUPS_PAGE,
  GEOFENCES_PAGE,
  DELIVERY_GEOFENCES_PAGE,
  CONTROL_TOWER_PAGE,
  GPT_DETAIL_PAGE,
  JOURNEYS_PAGE,
  CONVOYS_PAGE,
  LINKS_PAGE,
  REPORTS_PAGE,
  ROUTE_REPORTS_PAGE,
  PATHS_REPORTS_PAGE,
  ALARMS_REPORTS_PAGE,
  EVIDENCES_REPORTS_PAGE,
  EVIDENCE_REPORT_DETAIL_PAGE,
  TELEMETRY_REPORTS_PAGE,
  CONSUMPTION_REPORTS_PAGE,
  DOOR_REPORTS_PAGE,
  DELIVERY_REPORTS_PAGE,
  SETTINGS_PAGE,
  ACCOUNT_PAGE,
  TRACKING_PAGE,
  SECONDARIES_PAGE,
  PLACES_PAGE,
  DOWNLOADS_PAGE,
  NOTIFICATION_PAGE,
  LIVE_STATUS_PAGE,
  NOTIFICATION_EVIDENCES_PAGE,
  NOTIFICATION_EVIDENCE_DETAIL_PAGE,
];

export const SMALL_LIST_ITEM_HEIGHT = 50;
export const DEFAULT_LIST_ITEM_HEIGHT = 65;
export const LARGE_LIST_ITEM_HEIGHT = 80;
export const EXTRA_LARGE_LIST_ITEM_HEIGHT = 100;

export const SIDENAV_WIDTH = 64;
export const EXPANDED_SIDENAV_WIDTH = 200;

export const LIST_CARD_WIDTH = 300;
export const ASIDE_WIDTH = 300;

export const SUB_ACCOUNT_SECTION = 'subAccount';
export const USERS_SECTION = 'users';
export const NOTIFICATIONS_SECTION = 'notifications';
export const PLACES_SECTION = 'places';
export const LIVE_STATUS_SECTION = 'liveStatus';
export const INTEGRATIONS_SECTION = 'webServices';

export const HISTORIC_REPORT_TIME_INTERVAL = 6; //value in months
export const ROUTE_REPORT_TIME_INTERVAL = 3; //value in months

export const FILETYPE_PICTURE = 'PICTURE';
export const FILETYPE_VIDEO = 'VIDEO';
export const FILETYPE_STREAMING = 'STREAMING';
export const FILETYPE_ALARM = 'ALARM';

export const FEEDBACK = {
  created: (prefix: string, isPlural: boolean = false) => {
    if (isPlural) return `${prefix} se crearon con éxito.`;
    return `${prefix} se creó con éxito.`;
  },
  registered: (prefix: string, isPlural: boolean = false) => {
    if (isPlural) return `${prefix} se registraron con éxito.`;
    return `${prefix} se registró con éxito.`;
  },
  edited: (prefix: string, name: string = '') => `${prefix} "${name}" fue actualizado correctamente.`,
  deleted: (prefix: string, name: string = '') => `Se eliminó ${prefix.toLowerCase()} "${name}" correctamente.`,
  canceled: (prefix: string, name: string = '') => `Se canceló ${prefix.toLowerCase()} "${name}" correctamente.`,
  updated: (prefix: string) => `Se actualizó ${prefix.toLowerCase()} correctamente.`,
  failedCreation: (prefix: string) => `Ocurrió un error al crear ${prefix.toLowerCase()}, inténtalo nuevamente.`,
  failedRegistry: (prefix: string) => `Ocurrió un error al registrar ${prefix.toLowerCase()}, inténtalo nuevamente.`,
  failedEdition: (prefix: string, name: string = '') =>
    `Ocurrió un error al editar ${prefix.toLowerCase()} ${name}, inténtalo nuevamente.`,
  failedDeletion: (prefix: string, name: string = '') =>
    `Ocurrió un error al eliminar ${prefix.toLowerCase()} ${name}, inténtalo nuevamente.`,
  failedCancellation: (prefix: string, name: string = '') =>
    `Ocurrió un error al cancelar ${prefix.toLowerCase()} ${name}, inténtalo nuevamente.`,
  failedUpdate: (prefix: string) => `Ocurrió un error al actualizar ${prefix.toLowerCase()}, inténtalo nuevamente.`,
};

export const FEEDBACK_PREFIXES = {
  geofence: 'El geocerco',
  deliveryFence: 'El punto de entrega',
  group: 'El grupo',
  subAccount: 'La subcuenta',
  journey: 'El trayecto',
  user: 'El usuario',
  report: 'El reporte',
  place: 'El lugar',
  convoy: 'El convoy',
  asset: 'El activo',
  maintenanceType: 'El tipo de mantenimiento',
  maintenanceRule: 'La regla de mantenimiento',
  fleetService: 'El servicio',
  fleetServices: 'Los servicios',
  fleetMaintenance: 'El mantenimiento',
  fleetRepair: 'La reparación',
  document: 'El documento',
  driver: 'El conductor',
  refuel: 'La carga de combustible',
};

export const FOLLOW_ACTION = 'follow';
export const SECONDARIES_ACTION = 'secondaries';
export const ASSET_INFO_ACTION = 'assetInfo';
export const HISTORIC_REPORT_ACTION = 'historicReport';
export const SEND_COMMAND_ACTION = 'sendCommand';

export const ALL_WORKSPACES_PAGES_PERMISSIONS: PagePermissionName[] = [
  PagePermissionName.commands,
  PagePermissionName.dashboard,
  PagePermissionName.reports,
  PagePermissionName.settings,
];

export const VIDEO_REQUEST_WINDOW_WIDTH = 280;
export const VIDEO_REQUEST_WINDOW_HEIGHT = 300;
export const TIMELINE_WINDOW_HEIGHT = 128;

export const DEFAULT_TOP_CARD_HEIGHT = 230;
export const DEFAULT_BOTTOM_CARD_HEIGHT = 240;
export const DEFAULT_RIGHT_CARD_WIDTH = 210;

export const DEFAULT_ASPECT_RATIO = 22 / 15;

export const REQUIRED_FIELD_TEXT = 'Este campo es requerido';
export const SLUG_FIELD_ERROR_TEXT =
  'Usa solo minúsculas, números y guiones, sin espacios ni guiones al inicio o final';

export const IMAGE_EXTENSIONS = ['.png', '.jpg', '.jpeg'];
export const FILE_EXTENSIONS = ['.pdf', '.xml'];
export const ALL_EXTENSIONS = [...IMAGE_EXTENSIONS, ...FILE_EXTENSIONS];

export const ORDER_ASCENDING = 'asc';
export const ORDER_DESCENDING = 'desc';

export const ONLY_DATE_FORMAT = 'DD/MM/yyyy';

export const PAYMENT_METHOD_LABELS = {
  [PaymentMethod.debit]: 'Débito',
  [PaymentMethod.credit]: 'Crédito',
  [PaymentMethod.cash]: 'Efectivo',
  [PaymentMethod.vouchers]: 'Vales',
};

export const PAYMENT_METHOD_OPTIONS = getOptionsFromObject(PAYMENT_METHOD_LABELS);

export const SHARE_LINK_DURATION_LABELS = {
  [ShareLinkDuration.fourHours]: '4 horas',
  [ShareLinkDuration.eightHours]: '8 horas',
  [ShareLinkDuration.twelveHours]: '12 horas',
  [ShareLinkDuration.twentyFourHours]: '24 horas',
  [ShareLinkDuration.fourtyEigthHours]: '48 horas',
  [ShareLinkDuration.ninetySixHours]: '96 horas',
};
